import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from '@/store/swine';
import { axios } from "@/utils/axios";
import { Endpoints } from "@/utils/endpoints";
import { OperationType } from "@/models/swine/operationTypes/operationTypes.model";

@Module({
    namespaced: true,
    dynamic: true,
    name: 'operation-types.list',
    store,
})
class OperationTypesListStore extends VuexModule {
    response: OperationType[] = [];
    isLoading = false;
    error: any | null = null;

    @Mutation
    updateLoadingStatus(payload: boolean) {
        this.isLoading = payload;
    }

    @Mutation
    setError(error: any) {
        this.error = error;
    }

    @Mutation
    setResponse(payload: OperationType[]) {
        this.response.splice(0, this.response.length);
        payload.forEach((item) => {
            this.response.push(item);
        });
    }

    @Action
    getOperationTypes() {
        this.context.commit('updateLoadingStatus', true);
        this.context.commit('setError', null);
        try {
            axios.get(`${Endpoints.OperationTypes}`)
                .then((response) => {
                    this.context.commit('setResponse', response.data);
                })
        } catch (error) {
            this.context.commit('setError', error);
        }
        this.context.commit('updateLoadingStatus', false);
    }

}

export default getModule(OperationTypesListStore);